/**
 * Vulcan speaks Spanish. One locale, on purpose.
 *
 * The users are Chilean plant and engineering staff, and the register is
 * formal ("usted", no voseo). Copy lives in `locales/es.json` keyed by module
 * — `common`, `auth`, `flows`, `runs`, and `editor`/`catalog`/`validation`
 * owned by the editor slice — so adding `en` later is a second file and one
 * entry in `messages`, not a reshuffle.
 *
 * Composition mode (`legacy: false`) is required, not stylistic: components
 * use `useI18n()`, and the editor supplies its own message pack through
 * `useI18n({ useScope: 'local' })`, which the legacy API does not support.
 */
import { createI18n } from 'vue-i18n'

import es from './locales/es.json'

export const DEFAULT_LOCALE = 'es'

export type MessageSchema = typeof es

export const i18n = createI18n<[MessageSchema], typeof DEFAULT_LOCALE>({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  globalInjection: true,
  messages: { es },
})

// Screen readers and the browser's own hyphenation need the document language
// to match the copy; it is set once here rather than hard-coded in index.html,
// which stays correct when a second locale arrives.
document.documentElement.lang = DEFAULT_LOCALE
